module.exports = __webpack_public_path__ + "img/forum-2018.2d1127aa.jpg";